/**
 * Get the full URL for a mentor image
 * Handles both local images and Supabase Storage URLs
 */
export function getMentorImageUrl(image: string): string {
  // If image is already a full URL (Supabase), use as-is
  if (image.startsWith('http://') || image.startsWith('https://')) {
    return image;
  }

  // Otherwise, use local path
  return image;
}
